import { ToolStates } from './ToolStates';
import { NavigationStates } from './NavigationStates';
import { SwitchingState } from './SwitchingState';
import { ToolCategoryState } from './ToolCategoryState';
import { NotifState } from './NotifState';
import { LibraryState } from './LibraryState';
import { HomeState } from './HomeState'
import { Approver } from './Approver';
import { ProfileState } from './ProfileState';
import { UsageOverviewState } from './UsageOverviewState';
import { InquiryState } from './InquiryState';
import { Personalization } from './Personalization';

export const Context = () => {
    return {
        tool_state: ToolStates(),
        navigation_state: NavigationStates(),
        switching_state: SwitchingState(),
        tool_category_state: ToolCategoryState(),
        notif_state: NotifState(),
        library_state: LibraryState(),
        home_state: HomeState(),
        approver_state: Approver(),
        profile_state: ProfileState(),
        usage_state: UsageOverviewState(),
        inquiry_state: InquiryState(),
        personalization_state: Personalization()
    }
}